module.exports = __webpack_public_path__ + "static/volunteer_top_img2@2x-b7f5fd6e70bc52ccab9844fcdf474c2d.jpg";